function isNil(value){return null==value}module.exports=isNil;